export default "__VITE_ASSET__Bz9k68XV__"